(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-i18n-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-i18n-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-i18n-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-i18n-js-legacy'.");
    }root['kvision-kvision-i18n-js-legacy'] = factory(typeof this['kvision-kvision-i18n-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-i18n-js-legacy'], kotlin, this['kvision-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy) {
  'use strict';
  var i18n = $module$kvision_js_legacy.io.kvision.i18n;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var I18nManager = $module$kvision_js_legacy.io.kvision.i18n.I18nManager;
  function DefaultI18nManager(translations) {
    this.i18n_0 = require('gettext.js').default();
    var tmp$;
    tmp$ = translations.entries.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var json = JSON.parse(JSON.stringify(element.value));
      json[''].language = element.key;
      this.i18n_0.loadJSON(json, 'messages');
    }
  }
  DefaultI18nManager.prototype.gettext_25kzsl$ = function (key, args) {
    var tmp$, tmp$_0;
    this.i18n_0.setLocale(i18n.I18n.language);
    return (tmp$_0 = (tmp$ = this.i18n_0).gettext.apply(tmp$, [key].concat(args))) != null ? tmp$_0 : key;
  };
  DefaultI18nManager.prototype.ngettext_hjhpvv$ = function (singularKey, pluralKey, value, args) {
    var tmp$, tmp$_0;
    this.i18n_0.setLocale(i18n.I18n.language);
    return (tmp$_0 = (tmp$ = this.i18n_0).ngettext.apply(tmp$, [singularKey, pluralKey, value].concat(args))) != null ? tmp$_0 : value === 1 ? singularKey : pluralKey;
  };
  DefaultI18nManager.$metadata$ = {kind: Kind_CLASS, simpleName: 'DefaultI18nManager', interfaces: [I18nManager]};
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  var package$i18n = package$kvision.i18n || (package$kvision.i18n = {});
  package$i18n.DefaultI18nManager = DefaultI18nManager;
  DefaultI18nManager.prototype.ntr_rjan26$ = I18nManager.prototype.ntr_rjan26$;
  DefaultI18nManager.prototype.tr_61zpoe$ = I18nManager.prototype.tr_61zpoe$;
  DefaultI18nManager.prototype.trans_61zpoe$ = I18nManager.prototype.trans_61zpoe$;
  DefaultI18nManager.prototype.trans_pdl1vj$ = I18nManager.prototype.trans_pdl1vj$;
  return _;
}));

//# sourceMappingURL=kvision-kvision-i18n-js-legacy.js.map
